var React = require('react');

function Handshake (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.97 27.24a1 1 0 0 1-1.22.73l-4-1a1 1 0 0 1-.31-.14l-3-2a1 1 0 0 1 1.1-1.66l2.86 1.9 3.83.96a1 1 0 0 1 .74 1.21ZM31.56 15.2a1.99 1.99 0 0 1-1 1.15l-2.96 1.48-6.89 6.89a1 1 0 0 1-.95.26l-8-2a1 1 0 0 1-.34-.16l-6.94-4.95-3.03-1.52a2 2 0 0 1-.9-2.68l3.1-6.21a2 2 0 0 1 2.7-.9L9.1 7.93l6.62-1.9a1 1 0 0 1 .55 0l6.63 1.9 2.76-1.38a2 2 0 0 1 2.68.9l3.1 6.2a1.99 1.99 0 0 1 .12 1.54Zm-5.78 1.61-3.4-6.8h-3.97L13 15.25c1.58 1.01 4.06 1.29 6.29-.95a1 1 0 0 1 1.34-.08l4.3 3.45.85-.87ZM2.34 14.55l2.21 1.1 3.1-6.2-2.2-1.1-3.1 6.2Zm21.16 4.53-3.46-2.77c-2.45 2-5.55 2.26-8.12.62a2 2 0 0 1-.33-3.1l5.61-5.45-1.2-.34-6.3 1.8-3.42 6.84 6.15 4.4 7.26 1.81 3.81-3.8Zm6.16-4.53-3.1-6.2-2.22 1.1 3.1 6.2 2.21-1.1Z"}));
}

Handshake.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Handshake;

Handshake.default = Handshake;
